// JsFromRoutes CacheKey b1354e42d94fd28bc0fcc584cbc2dba9
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from "@js-from-routes/client";

export default {
  index: /* #__PURE__ */ definePathHelper(
    "get",
    "/admin/v2/receipts/:receipt_id/receipt_update_logs",
  ),
};
